import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import type { Product } from '../../../../data/product';
import { caseDiscount, casesSold, volumeDiscount } from '../../../../data/product';
import { preciseCurrencyFormatter } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

const expectedSavings90d = (p: Product) => {
  const cs90d = casesSold(p, 90);
  if (cs90d === 0) {
    return 0;
  }

  if (p.pricing.volume_discounts) {
    return cs90d * volumeDiscount(p, cs90d);
  }

  return cs90d * caseDiscount(p);
};

export const SavingsPotential90d: StrictColumnDef<ProductOrderItem> =
  defineColumn<ProductOrderItem>({
    id: 'Savings Potential 90d',
    minWidth: 80,
    accessorFn: (orderItem) => {
      const potentialSavings = expectedSavings90d(orderItem.product);

      if (-0.01 < potentialSavings && potentialSavings < 0.01) {
        return preciseCurrencyFormatter(0);
      }

      return preciseCurrencyFormatter(potentialSavings);
    },
    toCSV: (orderItem) => {
      const potentialSavings = expectedSavings90d(orderItem.product);

      return {
        'Savings Potential 90d': potentialSavings.toFixed(2),
      };
    },
    sortKeyFn: (orderItem) => expectedSavings90d(orderItem.product),
  });
